(function (window, document) {
    'use strict';

    document.querySelectorAll('link[data-carbuy-async-css]').forEach(function (link) {
        link.media = 'all';
        link.removeAttribute('data-carbuy-async-css');
    });

    const initial = window.CarBuyConsentInitial || {};
    const cookieName = initial.cookieName || 'carbuy_consent_v1';
    const cookieMaxAge = 60 * 60 * 24 * 180;
    const defaults = {
        necessary: true,
        analytics: false,
        marketing: false,
        saved: false
    };
    const listeners = [];

    function normalizePreferences(preferences) {
        return {
            necessary: true,
            analytics: preferences && preferences.analytics === true,
            marketing: preferences && preferences.marketing === true,
            saved: preferences && preferences.saved === true,
            updated_at: preferences && preferences.updated_at ? preferences.updated_at : null
        };
    }

    let currentPreferences = normalizePreferences(initial.preferences || defaults);

    function readCookie(name) {
        const parts = document.cookie ? document.cookie.split(';') : [];
        for (let i = 0; i < parts.length; i++) {
            const part = parts[i].trim();
            if (part.indexOf(name + '=') === 0) {
                return part.substring(name.length + 1);
            }
        }
        return '';
    }

    function readStoredConsent() {
        const raw = readCookie(cookieName);
        if (!raw) {
            return null;
        }
        try {
            return normalizePreferences(Object.assign({}, JSON.parse(decodeURIComponent(raw)), { saved: true }));
        } catch (e) {
            return null;
        }
    }

    function writeConsent(preferences) {
        const stored = {
            necessary: true,
            analytics: preferences.analytics === true,
            marketing: preferences.marketing === true,
            updated_at: new Date().toISOString()
        };
        const secure = window.location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = cookieName + '=' + encodeURIComponent(JSON.stringify(stored))
            + '; path=/; max-age=' + cookieMaxAge + '; SameSite=Lax' + secure;
        return normalizePreferences(Object.assign({}, stored, { saved: true }));
    }

    function toGoogleConsent(preferences) {
        const analytics = preferences.analytics ? 'granted' : 'denied';
        const marketing = preferences.marketing ? 'granted' : 'denied';
        return {
            analytics_storage: analytics,
            ad_storage: marketing,
            ad_user_data: marketing,
            ad_personalization: marketing
        };
    }

    function pushConsentUpdate(source) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'carbuy_consent_update',
            consent_source: source || 'unknown',
            analytics_consent: currentPreferences.analytics ? 'granted' : 'denied',
            marketing_consent: currentPreferences.marketing ? 'granted' : 'denied'
        });
    }

    function ensureGa4Loaded(done) {
        if (window._carbuyGa4Loaded === true) {
            if (typeof done === 'function') {
                done();
            }
            return;
        }
        if (window._carbuyGa4Loaded === 'loading') {
            if (typeof done === 'function') {
                window._carbuyGa4LoadQueue = window._carbuyGa4LoadQueue || [];
                window._carbuyGa4LoadQueue.push(done);
            }
            return;
        }

        var tags = window.CarBuyGoogleTags || {};
        var ga4Id = tags.ga4Id;
        if (!ga4Id) {
            return;
        }

        window._carbuyGa4Loaded = 'loading';
        var script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(ga4Id);
        script.onload = function () {
            var ga4Config = { send_page_view: false };
            window.gtag('config', ga4Id, ga4Config);
            window._carbuyGa4Loaded = true;
            if (typeof done === 'function') {
                done();
            }
            var queue = window._carbuyGa4LoadQueue || [];
            window._carbuyGa4LoadQueue = [];
            queue.forEach(function (callback) {
                try {
                    callback();
                } catch (e) {
                    // Analytics callbacks must not break the page.
                }
            });
        };
        script.onerror = function () {
            window._carbuyGa4Loaded = false;
            var queue = window._carbuyGa4LoadQueue || [];
            window._carbuyGa4LoadQueue = [];
            queue.forEach(function (callback) {
                try {
                    callback();
                } catch (e) {
                    // Analytics callbacks must not break the page.
                }
            });
        };
        document.head.appendChild(script);
    }

    function applyGoogleConsent(source) {
        window.dataLayer = window.dataLayer || [];
        window.gtag = window.gtag || function () {
            window.dataLayer.push(arguments);
        };
        window.gtag('consent', 'update', toGoogleConsent(currentPreferences));
        pushConsentUpdate(source);
        if (currentPreferences.analytics) {
            ensureGa4Loaded();
        }
    }

    function notifyListeners(source) {
        const detail = {
            preferences: Object.assign({}, currentPreferences),
            source: source || 'unknown'
        };
        listeners.slice().forEach(function (listener) {
            try {
                listener(detail.preferences, detail.source);
            } catch (e) {
                // Consent listeners should not interrupt the page.
            }
        });
        try {
            window.dispatchEvent(new CustomEvent('carbuy:consent-change', { detail: detail }));
        } catch (e) {
            // Older browsers without CustomEvent support can ignore this.
        }
    }

    function save(preferences, source) {
        currentPreferences = writeConsent(preferences);
        applyGoogleConsent(source || 'save');
        notifyListeners(source || 'save');
        hideBanner();
        afterLeasingTrackingStateChange();
    }

    function hasCategory(category) {
        return currentPreferences[category] === true;
    }

    function safePayload(payload) {
        const clean = {};
        if (!payload || typeof payload !== 'object') {
            return clean;
        }
        Object.keys(payload).forEach(function (key) {
            const value = payload[key];
            if (value === null || value === undefined) {
                return;
            }
            if (['string', 'number', 'boolean'].indexOf(typeof value) !== -1) {
                clean[key] = value;
            }
        });
        return clean;
    }

    function enrichLeasingPayloadForDataLayer(payload) {
        const enriched = safePayload(payload);
        if (enriched.value && enriched.currency) {
            return enriched;
        }
        if (window.CarBuyMetaPixel && typeof window.CarBuyMetaPixel.buildLeasingPricingFromExtra === 'function') {
            const pricing = window.CarBuyMetaPixel.buildLeasingPricingFromExtra(enriched);
            if (pricing.loan_amount) {
                enriched.value = pricing.loan_amount;
                enriched.currency = 'EUR';
            } else if (pricing.vehicle_price) {
                enriched.value = pricing.vehicle_price;
                enriched.currency = 'EUR';
            }
        }
        return enriched;
    }

    function eventId() {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') {
            return window.crypto.randomUUID();
        }
        return 'cb_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
    }

    const GA4_EVENT_ALIASES = {
        vehicle_view: 'view_item',
        catalog_search: 'search',
        leasing_lead_submit: 'generate_lead',
        leasing_step1_complete: 'generate_lead',
        leasing_form_open: 'begin_checkout',
        add_to_wishlist: 'add_to_wishlist',
        newsletter_signup: 'sign_up',
        sell_car_lead_submit: 'generate_lead',
        car_order_lead_submit: 'generate_lead',
        vehicle_contact_intent: 'contact',
        email_click: 'contact',
        phone_click: 'contact',
        whatsapp_click: 'contact',
        sms_click: 'contact'
    };

    const LEASING_LEAD_TRACKED_PREFIX = 'carbuy_leasing_lead_tracked:';
    const LEASING_STEP1_TRACKED_PREFIX = 'carbuy_leasing_step1_tracked:';
    const LEASING_STEP2_TRACKED_PREFIX = 'carbuy_leasing_step2_tracked:';
    const LEASING_COMPLETE_TRACKED_PREFIX = 'carbuy_leasing_complete_tracked:';
    const PENDING_LEASING_KEY = 'carbuy_pending_leasing_track_v1';
    const LEASING_STEP1_DONE_STATUSES = [
        'step_1_complete',
        'step_2_in_progress',
        'step_2_complete',
        'connecting_bank',
        'bank_connected',
        'submitted'
    ];
    const LEASING_STEP2_DONE_STATUSES = [
        'step_2_complete',
        'connecting_bank',
        'bank_connected',
        'submitted'
    ];

    function resolveLeasingApplicationRef(payload) {
        const clean = safePayload(payload);
        if (clean.application_ref) {
            return String(clean.application_ref);
        }
        if (clean.application_id) {
            return 'id:' + String(clean.application_id);
        }
        const token = readCookie('leasing_application');
        if (token) {
            return 'token:' + token;
        }
        return '';
    }

    function queuePendingLeasingEvent(type, payload) {
        try {
            if (!window.sessionStorage) {
                return;
            }
            const list = JSON.parse(window.sessionStorage.getItem(PENDING_LEASING_KEY) || '[]');
            list.push({
                type: type,
                payload: safePayload(payload),
                ts: Date.now()
            });
            window.sessionStorage.setItem(PENDING_LEASING_KEY, JSON.stringify(list.slice(-10)));
        } catch (e) {
            // sessionStorage may be disabled.
        }
    }

    function flushPendingLeasingTracking() {
        if (!hasCategory('analytics')) {
            return;
        }
        try {
            if (!window.sessionStorage) {
                return;
            }
            const raw = window.sessionStorage.getItem(PENDING_LEASING_KEY);
            if (!raw) {
                return;
            }
            window.sessionStorage.removeItem(PENDING_LEASING_KEY);
            const list = JSON.parse(raw);
            if (!Array.isArray(list)) {
                return;
            }
            list.forEach(function (item) {
                if (!item || !item.type || !item.payload) {
                    return;
                }
                if (item.type === 'step1') {
                    trackLeasingStep1Conversion(item.payload);
                } else if (item.type === 'step2') {
                    trackLeasingStep2Once(item.payload);
                } else if (item.type === 'complete') {
                    trackLeasingCompleteConversion(item.payload);
                }
            });
        } catch (e) {
            // Pending replay must not break the page.
        }
    }

    function bootstrapLeasingPageTracking() {
        const ctx = window.CarBuyLeasingPageContext;
        if (!ctx || ctx.has_application !== true) {
            return;
        }
        const payload = {
            applicant_type: ctx.applicant_type || 'person',
            car_id: ctx.car_id || '',
            form_location: 'leasing_v2_page',
            application_ref: ctx.application_ref || '',
            application_id: ctx.application_id || 0
        };
        const status = String(ctx.application_status || '');
        if (LEASING_STEP1_DONE_STATUSES.indexOf(status) !== -1) {
            trackLeasingStep1Conversion(payload);
        }
        if (LEASING_STEP2_DONE_STATUSES.indexOf(status) !== -1) {
            trackLeasingStep2Once(payload);
        }
    }

    function afterLeasingTrackingStateChange() {
        flushPendingLeasingTracking();
        bootstrapLeasingPageTracking();
    }

    function pushDataLayerEvent(eventName, cleanPayload, id) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({
            event: eventName,
            event_id: id
        }, cleanPayload));
    }

    function pushGtagEvent(eventName, cleanPayload, id) {
        if (typeof window.gtag !== 'function') {
            return;
        }
        window.gtag('event', eventName, Object.assign({
            event_id: id,
            transport_type: 'beacon'
        }, cleanPayload));
    }

    function pushAnalyticsEvent(eventName, cleanPayload, id) {
        pushDataLayerEvent(eventName, cleanPayload, id);
        pushGtagEvent(eventName, cleanPayload, id);
    }

    function dispatchTrack(eventName, payload) {
        const cleanPayload = safePayload(payload);
        const id = eventId();
        pushAnalyticsEvent(eventName, cleanPayload, id);

        const ga4Name = GA4_EVENT_ALIASES[eventName];
        if (ga4Name && ga4Name !== eventName) {
            pushAnalyticsEvent(ga4Name, cleanPayload, id);
        }
    }

    function dispatchTrackDataLayer(eventName, payload) {
        const cleanPayload = safePayload(payload);
        const id = eventId();
        pushDataLayerEvent(eventName, cleanPayload, id);

        const ga4Name = GA4_EVENT_ALIASES[eventName];
        if (ga4Name && ga4Name !== eventName) {
            pushDataLayerEvent(ga4Name, cleanPayload, id);
        }
        return { cleanPayload: cleanPayload, id: id };
    }

    function dispatchTrackGtag(eventName, payload, tracked) {
        const cleanPayload = tracked && tracked.cleanPayload ? tracked.cleanPayload : safePayload(payload);
        const id = tracked && tracked.id ? tracked.id : eventId();
        pushGtagEvent(eventName, cleanPayload, id);

        const ga4Name = GA4_EVENT_ALIASES[eventName];
        if (ga4Name && ga4Name !== eventName) {
            pushGtagEvent(ga4Name, cleanPayload, id);
        }
    }

    function leasingLeadDedupKey(applicationRef) {
        return LEASING_LEAD_TRACKED_PREFIX + (applicationRef || '_unknown');
    }

    function isLeasingLeadTracked(applicationRef) {
        const dedupRef = applicationRef || '_unknown';
        try {
            if (window.sessionStorage) {
                return window.sessionStorage.getItem(leasingLeadDedupKey(dedupRef)) === '1';
            }
        } catch (e) {
            // sessionStorage may be disabled.
        }
        return false;
    }

    function markLeasingLeadTracked(applicationRef) {
        const dedupRef = applicationRef || '_unknown';
        try {
            if (window.sessionStorage) {
                window.sessionStorage.setItem(leasingLeadDedupKey(dedupRef), '1');
            }
        } catch (e) {
            // sessionStorage may be disabled.
        }
    }

    function track(eventName, payload) {
        if (!eventName || typeof eventName !== 'string') {
            return;
        }
        if (!hasCategory('analytics')) {
            return;
        }
        const tracked = dispatchTrackDataLayer(eventName, payload);
        ensureGa4Loaded(function () {
            dispatchTrackGtag(eventName, payload, tracked);
        });
    }

    function isLeasingFunnelStepTracked(storagePrefix, applicationRef) {
        const dedupRef = applicationRef || '_unknown';
        try {
            if (window.sessionStorage) {
                return window.sessionStorage.getItem(storagePrefix + dedupRef) === '1';
            }
        } catch (e) {
            // sessionStorage may be disabled.
        }
        return false;
    }

    function markLeasingFunnelStepTracked(storagePrefix, applicationRef) {
        const dedupRef = applicationRef || '_unknown';
        try {
            if (window.sessionStorage) {
                window.sessionStorage.setItem(storagePrefix + dedupRef, '1');
            }
        } catch (e) {
            // sessionStorage may be disabled.
        }
    }

    function trackLeasingFunnelStepOnce(eventName, storagePrefix, payload) {
        if (!hasCategory('analytics')) {
            if (eventName === 'leasing_step2_complete') {
                queuePendingLeasingEvent('step2', payload);
            }
            return;
        }
        const cleanPayload = enrichLeasingPayloadForDataLayer(payload);
        const applicationRef = resolveLeasingApplicationRef(cleanPayload);
        if (isLeasingFunnelStepTracked(storagePrefix, applicationRef)) {
            return;
        }

        const tracked = dispatchTrackDataLayer(eventName, cleanPayload);
        ensureGa4Loaded(function () {
            dispatchTrackGtag(eventName, cleanPayload, tracked);
            markLeasingFunnelStepTracked(storagePrefix, applicationRef);
        });
    }

    function trackLeasingLeadOnce(payload) {
        const cleanPayload = enrichLeasingPayloadForDataLayer(payload);
        if (!hasCategory('analytics')) {
            queuePendingLeasingEvent('complete', cleanPayload);
            return;
        }
        const applicationRef = resolveLeasingApplicationRef(cleanPayload);
        if (isLeasingFunnelStepTracked(LEASING_COMPLETE_TRACKED_PREFIX, applicationRef)) {
            return;
        }

        const leadAlreadySent = isLeasingLeadTracked(applicationRef);
        const tracked = dispatchTrackDataLayer('leasing_complete', cleanPayload);
        if (!leadAlreadySent) {
            pushDataLayerEvent('generate_lead', tracked.cleanPayload, tracked.id);
        }

        ensureGa4Loaded(function () {
            dispatchTrackGtag('leasing_complete', cleanPayload, tracked);
            if (!leadAlreadySent) {
                pushGtagEvent('generate_lead', tracked.cleanPayload, tracked.id);
                markLeasingLeadTracked(applicationRef);
            }
            markLeasingFunnelStepTracked(LEASING_COMPLETE_TRACKED_PREFIX, applicationRef);
        });
    }

    function trackLeasingStep1Once(payload, done) {
        const cleanPayload = enrichLeasingPayloadForDataLayer(payload);
        if (!hasCategory('analytics')) {
            queuePendingLeasingEvent('step1', cleanPayload);
            if (typeof done === 'function') {
                done();
            }
            return;
        }
        const applicationRef = resolveLeasingApplicationRef(cleanPayload);
        if (isLeasingFunnelStepTracked(LEASING_STEP1_TRACKED_PREFIX, applicationRef)) {
            if (typeof done === 'function') {
                done();
            }
            return;
        }

        const tracked = dispatchTrackDataLayer('leasing_step1_complete', cleanPayload);
        ensureGa4Loaded(function () {
            dispatchTrackGtag('leasing_step1_complete', cleanPayload, tracked);
            markLeasingFunnelStepTracked(LEASING_STEP1_TRACKED_PREFIX, applicationRef);
            markLeasingLeadTracked(applicationRef);
            if (typeof done === 'function') {
                done();
            }
        });
    }

    function trackLeasingStep1Conversion(payload, done) {
        if (window.CarBuyMetaPixel && typeof window.CarBuyMetaPixel.trackLeasingStep1Lead === 'function') {
            window.CarBuyMetaPixel.trackLeasingStep1Lead(payload);
        }
        trackLeasingStep1Once(payload, done);
    }

    function trackLeasingCompleteConversion(payload, done) {
        if (window.CarBuyMetaPixel && typeof window.CarBuyMetaPixel.trackLeasingApplicationLead === 'function') {
            window.CarBuyMetaPixel.trackLeasingApplicationLead(payload);
        }
        if (!hasCategory('analytics')) {
            queuePendingLeasingEvent('complete', payload);
            if (typeof done === 'function') {
                done();
            }
            return;
        }
        const cleanPayload = enrichLeasingPayloadForDataLayer(payload);
        const applicationRef = resolveLeasingApplicationRef(cleanPayload);
        if (isLeasingFunnelStepTracked(LEASING_COMPLETE_TRACKED_PREFIX, applicationRef)) {
            if (typeof done === 'function') {
                done();
            }
            return;
        }

        const leadAlreadySent = isLeasingLeadTracked(applicationRef);
        const tracked = dispatchTrackDataLayer('leasing_complete', cleanPayload);
        if (!leadAlreadySent) {
            pushDataLayerEvent('generate_lead', tracked.cleanPayload, tracked.id);
        }

        ensureGa4Loaded(function () {
            dispatchTrackGtag('leasing_complete', cleanPayload, tracked);
            if (!leadAlreadySent) {
                pushGtagEvent('generate_lead', tracked.cleanPayload, tracked.id);
                markLeasingLeadTracked(applicationRef);
            }
            markLeasingFunnelStepTracked(LEASING_COMPLETE_TRACKED_PREFIX, applicationRef);
            if (typeof done === 'function') {
                done();
            }
        });
    }

    function trackLeasingStep2Once(payload) {
        trackLeasingFunnelStepOnce('leasing_step2_complete', LEASING_STEP2_TRACKED_PREFIX, payload);
    }

    function trackCatalogSearch(payload) {
        track('catalog_search', payload || {});
        if (window.CarBuyMetaPixel && typeof window.CarBuyMetaPixel.track === 'function') {
            window.CarBuyMetaPixel.track('Search', payload || {});
        }
    }

    function showBanner(options) {
        const banner = document.querySelector('[data-cookie-consent]');
        if (!banner) {
            return;
        }
        const expanded = !!(options && options.expanded);
        const details = banner.querySelector('[data-cookie-consent-details]');
        if (details) {
            details.hidden = !expanded;
        }
        banner.classList.toggle('is-expanded', expanded);
        banner.hidden = false;
        banner.classList.add('is-visible');
    }

    function hideBanner() {
        const banner = document.querySelector('[data-cookie-consent]');
        if (!banner) {
            return;
        }
        banner.classList.remove('is-visible', 'is-expanded');
        const details = banner.querySelector('[data-cookie-consent-details]');
        if (details) {
            details.hidden = true;
        }
        banner.hidden = true;
    }

    function scheduleInitialBanner() {
        if (currentPreferences.saved) {
            return;
        }
        let shown = false;
        const reveal = function () {
            if (shown) {
                return;
            }
            shown = true;
            // Compact bar by default so hero can remain LCP on first visit.
            showBanner({ expanded: false });
        };
        const afterPaint = function () {
            if (typeof window.requestAnimationFrame === 'function') {
                window.requestAnimationFrame(function () {
                    window.requestAnimationFrame(reveal);
                });
            } else {
                setTimeout(reveal, 0);
            }
        };
        if (document.readyState === 'complete') {
            afterPaint();
        } else {
            window.addEventListener('load', afterPaint, { once: true });
            // Slow networks: still show consent without waiting forever.
            setTimeout(afterPaint, 2500);
        }
    }

    function syncInputs() {
        document.querySelectorAll('[data-cookie-consent-input]').forEach(function (input) {
            const category = input.getAttribute('data-cookie-consent-input');
            input.checked = hasCategory(category);
        });
    }

    function selectedPreferencesFromInputs() {
        const preferences = {
            necessary: true,
            analytics: false,
            marketing: false
        };
        document.querySelectorAll('[data-cookie-consent-input]').forEach(function (input) {
            const category = input.getAttribute('data-cookie-consent-input');
            if (category === 'analytics' || category === 'marketing') {
                preferences[category] = input.checked === true;
            }
        });
        return preferences;
    }

    function bindBanner() {
        const stored = readStoredConsent();
        if (stored) {
            currentPreferences = stored;
            applyGoogleConsent('loaded');
        }
        syncInputs();
        afterLeasingTrackingStateChange();

        document.querySelectorAll('[data-cookie-consent-action]').forEach(function (button) {
            button.addEventListener('click', function () {
                const action = button.getAttribute('data-cookie-consent-action');
                if (action === 'customize') {
                    showBanner({ expanded: true });
                    return;
                }
                if (action === 'all') {
                    save({ necessary: true, analytics: true, marketing: true }, 'accept_all');
                    return;
                }
                if (action === 'necessary') {
                    save({ necessary: true, analytics: false, marketing: false }, 'necessary_only');
                    return;
                }
                save(selectedPreferencesFromInputs(), 'save_choices');
            });
        });

        document.querySelectorAll('[data-cookie-consent-open]').forEach(function (button) {
            button.addEventListener('click', function (event) {
                event.preventDefault();
                syncInputs();
                showBanner({ expanded: true });
            });
        });

        scheduleInitialBanner();
    }

    window.CarBuyConsent = {
        get: function () {
            return Object.assign({}, currentPreferences);
        },
        hasCategory: hasCategory,
        onChange: function (listener) {
            if (typeof listener === 'function') {
                listeners.push(listener);
            }
        },
        open: function () {
            syncInputs();
            showBanner({ expanded: true });
        },
        save: save,
        acceptAll: function () {
            save({ necessary: true, analytics: true, marketing: true }, 'accept_all');
        },
        necessaryOnly: function () {
            save({ necessary: true, analytics: false, marketing: false }, 'necessary_only');
        }
    };

    window.CarBuyAnalytics = {
        track: track,
        trackCatalogSearch: trackCatalogSearch,
        trackLeasingLeadOnce: trackLeasingLeadOnce,
        trackLeasingStep1Once: trackLeasingStep1Once,
        trackLeasingStep2Once: trackLeasingStep2Once,
        trackLeasingStep1Conversion: trackLeasingStep1Conversion,
        trackLeasingCompleteConversion: trackLeasingCompleteConversion
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bindBanner);
    } else {
        bindBanner();
    }
})(window, document);
